import { css } from '@emotion/react';
import { type Property } from 'csstype';
import type { Theme } from '~/_shared/themes/theme.model';

export const tableHeaderCellStyle = ({ colSpan }: {
  readonly colSpan: number;
}) =>
  (theme: Theme) => css({
    whiteSpace: 'nowrap',
    fontWeight: 400,
    fontSize: 14,
    height: 28,
    color: theme.textColors.quaternary,
    textTransform: 'uppercase',
    textAlign: 'left',
    alignContent: 'center',
    boxSizing: 'border-box',
    background: theme.backgroundColors.quaternary,
    gridColumn: `span ${colSpan}`,
    padding: '0 10px',

    '&:first-of-type': {
      borderTopLeftRadius: 8,
    },
    '&:last-of-type': {
      borderTopRightRadius: 8,
    },
  });

export const getNoResultsRowStyles = ({ columnCount }: {readonly columnCount: number}) =>
  (theme: Theme) => css({
    padding: '10px 0',
    textAlign: 'center',
    background: theme.backgroundColors.primary,
    gridColumn: `span ${columnCount}`,
  });

export const cellStyles = (theme: Theme) => css({
  borderBottom: `1px solid ${theme.borderColors.primary}`,
  background: theme.backgroundColors.secondary,
  height: 36,
  alignContent: 'center',
  padding: '0 10px',

  '.row:hover &': {
    backgroundColor: theme.backgroundColors.secondaryHover,
  },
});

export const checkboxCellStyles = (theme: Theme) => css([
  cellStyles(theme),
  {
    paddingRight: 0,
  },
]);

export const dataCellStyle = (theme: Theme) => css([
  cellStyles(theme),
  {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
]);

export const rowStyle = css({
  display: 'contents',
});

export const gridStyle = ({ columnWidths }: {
  readonly columnWidths: ReadonlyArray<Property.ColumnWidth>;
}) =>
  (theme: Theme) => css({
    width: '100%',
    display: 'grid',
    justifyContent: 'stretch',
    gridTemplateColumns: `${columnWidths.join(' ')}`,
    gridAutoRows: 'min-content',
    boxShadow: `0 2px 5px ${theme.shadowColors.secondary}`,
  });
